// Keep selection and insertion compatible with the app's useSponsoredPlacements/placement.ts.
// Only these surfaces have a web renderer wired up so far.
export const WEB_SPONSORED_FORMATS = {
  SEARCH_RESULTS: ['INLINE_BANNER'],
  SEARCH_TASTE: ['NATIVE_ALBUM'],
  SEARCH_CONTINUE: ['NATIVE_ALBUM'],
  ARTIST_DETAIL: ['INLINE_BANNER'],
  ALBUM_DETAIL: ['INLINE_BANNER'],
  ALBUMS_RELEASES: ['NATIVE_ALBUM', 'INLINE_BANNER'],
  ALBUMS_RELEASES_KR: ['NATIVE_ALBUM', 'INLINE_BANNER'],
  ALBUMS_RELEASES_GLOBAL: ['NATIVE_ALBUM', 'INLINE_BANNER'],
  ALBUMS_RECOMMENDED: ['NATIVE_ALBUM', 'INLINE_BANNER'],
  REVIEWS_FEED: ['INLINE_BANNER'],
  REVIEWS_ALBUMS: ['INLINE_BANNER'],
  PLAYLISTS_FEED: ['INLINE_BANNER'],
  HOME_DISCOVERY: ['NATIVE_ALBUM'],
  HOME_DIVIDED_OPINION: ['COLLECTION'],
  EXPLORE_LATEST_KR: ['NATIVE_ALBUM'],
  EXPLORE_LATEST_GLOBAL: ['NATIVE_ALBUM'],
  EXPLORE_RECOMMENDED: ['NATIVE_ALBUM', 'COLLECTION'],
};
export function selectCampaigns(campaigns = [], key, hidden = []) {
  return campaigns
    .filter((campaign) => !hidden.includes(campaign.id))
    .map((campaign) => ({
      ...campaign,
      placements: (campaign.placements || [])
        .filter((p) => p.placementKey === key && WEB_SPONSORED_FORMATS[key]?.includes(p.format))
        .sort((a, b) => a.position - b.position),
    }))
    .filter(
      (campaign) =>
        campaign.placements.length &&
        (campaign.placements[0].format === 'INLINE_BANNER' || campaign.albums?.length),
    )
    .sort(
      (a, b) =>
        a.placements[0].startAfterOrganic - b.placements[0].startAfterOrganic ||
        a.placements[0].position - b.placements[0].position ||
        a.id - b.id,
    );
}
export function planSponsoredInsertions(campaigns, organicCount) {
  return campaigns
    .flatMap((campaign) => {
      const p = campaign.placements[0];
      if (!p) return [];
      const slots = [];
      let at = Math.max(0, p.startAfterOrganic ?? 0);
      const max = Math.min(Math.max(p.maxPerScreen ?? 1, 1), 3);
      for (let occurrence = 0; occurrence < max; occurrence++) {
        slots.push({ at: Math.min(at, organicCount), campaign, occurrence });
        if (!p.repeatEvery) break;
        at += Math.max(p.repeatEvery, 6);
      }
      return slots;
    })
    .sort(
      (a, b) =>
        a.at - b.at ||
        a.campaign.placements[0].position - b.campaign.placements[0].position ||
        a.campaign.id - b.campaign.id ||
        a.occurrence - b.occurrence,
    );
}
export function sponsoredRail(items = [], campaigns = [], limit = 12) {
  const native = campaigns.filter(
    (c) => c.placements[0]?.format === 'NATIVE_ALBUM' && c.albums?.length,
  );
  const advertised = new Set(native.flatMap((c) => c.albums.map((album) => album.id)));
  const entries = items
    .map((item, index) => ({ kind: 'organic', item, position: index + 1 }))
    .filter(({ item }) => !advertised.has(item.albumId || item.id));
  planSponsoredInsertions(native, entries.length).forEach(
    ({ at, campaign, occurrence }, offset) => {
      entries.splice(at + offset, 0, { kind: 'sponsored', campaign, occurrence });
    },
  );
  return entries.slice(0, limit);
}
export function safeExternalUrl(value) {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && !url.username && !url.password ? url.href : null;
  } catch {
    return null;
  }
}
export function campaignDestination(campaign, album) {
  const value = campaign.destinationValue?.trim();
  if (campaign.destinationType === 'EXTERNAL') return safeExternalUrl(value);
  if (campaign.destinationType === 'PLAYLIST' && value)
    return `/lists/${encodeURIComponent(value)}`;
  if (campaign.destinationType === 'ARTIST' && value)
    return `/artists/${encodeURIComponent(value)}`;
  if (album?.slug) return `/reviews/${encodeURIComponent(album.slug)}`;
  if (album?.id) return `/reviews/local/${encodeURIComponent(album.id)}`;
  if (album?.sourceId)
    return `/reviews/${String(album.albumSource || 'APPLE_MUSIC').toLowerCase()}/${encodeURIComponent(album.sourceId)}`;
  return null;
}
